import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const LoadingCard = () => (
	<div
		data-testid='geolocation-loading-card'
		className='gps-device-loading-container'
	>
		<div>
			<Skeleton height={40} />
		</div>
		<div>
			<Skeleton height={16} width={230} />
			<div className='device-info-row'>
				<Skeleton height={12} width={120} />
				<Skeleton height={12} width={60} />
			</div>
			<Skeleton height={12} width={170} />
		</div>
		<div>
			<Skeleton height={12} width={70} style={{ marginLeft: '10px' }}  />
			<Skeleton height={12} width={80} />
		</div>
	</div>
);
